<template>
  <label class="vin-label">
    <span class="vin-label__text" v-show="labelText">
      {{ labelText }}
      <sup>*</sup>
    </span>
    <input
      v-if="mask"
      class="vin-label__input"
      v-mask="mask"
      v-bind="$attrs"
      :placeholder="placeholder"
      :value="value"
      :name="name"
      @input="handleInput"
    />
    <input
      v-else
      class="vin-label__input"
      v-bind="$attrs"
      :placeholder="placeholder"
      :value="value"
      :name="name"
      @input="handleInput"
    />
    <span class="vin-label__error" v-if="errorText">
      {{ errorText }}
    </span>
  </label>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    mask: {
      type: String
    },
    toUpperCase: {
      type: Boolean,
      default: false
    },
    labelText: String,
    errorText: String,
    inputType: String,
    placeholder: String,
    name: String
  },

  data() {
    return {
      value: ""
    };
  },

  methods: {
    handleInput(e) {
      this.value = this.toUpperCase
        ? e.target.value.toUpperCase()
        : e.target.value;
      this.$emit("inputValue", this.value);
    }
  }
};
</script>

<style lang="sass">
@import '@/assets/sass/partials/_sass-components.sass'
.vin-label
  display: inline-flex
  flex-direction: column
  text-align: left
  width: 370px
  +res('mob')
    max-width: 100%

  &__text
    font-family: $text-font-book
    color: $inputLabel
    display: block
    font-size: 15px
    font-weight: 300
    line-height: 1.38
    letter-spacing: normal
    margin-bottom: 10px
    +res('mob')
      font-size: 16px
      max-width: 280px
      margin-right: auto
      padding-left: 15px


    sup
      font-size: 13px
      color: $red
      vertical-align: bottom
      margin-left: 5px

  &__input
    display: block
    width: 100%
    height: 48px
    border-radius: 4px
    background-color: $grey
    caret-color: $red
    color: $black
    border: none
    outline: none
    padding-left: 20px
    font-family: $text-font-book
    font-size: 15px
    font-weight: normal
    text-align: left
    transition: background .3s
    margin-bottom: 5px
    box-shadow: none
    +res('desk')
      &:hover
        background-color: $form-hover
    +res('mob')
      font-size: 16px
      width: 100%
      margin: auto

    &:focus
      background-color: #ffffff
      box-shadow: 0 2px 10px 0 rgba(194, 192, 192, 0.5)
      // +res('mob')
      //   box-shadow: none

  &__error
    font-size: 13px
    color: $red
    text-align: right
    // padding-left: 5px
    margin-bottom: 5px
    position: absolute
    bottom: -16px
    left: 0
    +res('mob')
      left: 8px
      text-align: left
      bottom: -22px
    &.checkbox-error
      display: flex
      justify-content: center
      width: 100%
      margin-top: 5px
      bottom: -25px
      text-align: center
      +res('mob')
        bottom: -35px
        // text-align: left
</style>
